// /opt/isp_erp/frontend/src/api/finanzas/facturas.api.js
import axios from '../axios';

export const facturasApi = {
  // Obtener todas las facturas con filtros
  listar: (params = {}) => {
    // Limpiar parámetros vacíos antes de enviar
    const cleanParams = {};
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        cleanParams[key] = params[key];
      }
    });
    return axios.get('/facturas', { params: cleanParams });
  },

  // Obtener una factura por ID
  obtener: (id) => axios.get(`/facturas/${id}`),

  // Obtener por número
  obtenerPorNumero: (numero) => axios.get(`/facturas/numero/${numero}`),

  // Crear factura
  crear: (data) => axios.post('/facturas', data),

  // Actualizar factura
  actualizar: (id, data) => axios.put(`/facturas/${id}`, data),

  // Anular factura
  anular: (id, motivo) => axios.post(`/facturas/${id}/anular?motivo=${encodeURIComponent(motivo)}`),

  // Facturas vencidas
  vencidas: () => axios.get('/facturas/vencidas'),

  // Generar mora
  generarMora: (dias = 5) => axios.post(`/facturas/generar-mora?dias_mora=${dias}`),

  // Resumen de cliente
  resumenCliente: (customerId) => axios.get(`/facturas/cliente/${customerId}/resumen`),

  // Eliminar factura
  eliminar: (id, motivo) => axios.delete(`/facturas/${id}?motivo=${encodeURIComponent(motivo)}`),

  // Restaurar factura
  restaurar: (id) => axios.post(`/facturas/${id}/restaurar`),

  // ======================================================
  // NUEVOS MÉTODOS PARA PDF, EXCEL Y EMAIL
  // ======================================================

  // Generar PDF de factura
  generarPDF: (id) => axios.get(`/facturas/${id}/pdf`, { responseType: 'blob' }),

  // Exportar facturas a Excel
  exportarExcel: (params) => axios.get('/facturas/exportar/excel', { 
    params, 
    responseType: 'blob' 
  }),

  // Enviar factura por email
  enviarPorEmail: (id, data) => axios.post(`/facturas/${id}/enviar-email`, data),

};

